import * as schemas from "../schemas-JSON";

export function GetActionInfo(actionName) {
	var action = {};

	// ! certains schemas prennent des arguments, prevcolumnnames, et pour base de données, beaucoup plus
	// let functionName = "schema_" + (actionName.replace(" ", "_")).toLowerCase();
	// https://stackoverflow.com/questions/359788/how-to-execute-a-javascript-function-when-i-have-its-name-as-a-string
	// action.jsonSchema = schemas[functionName](prevColumnNames);

	let actionLabel = "";

	let FindActionLabel = () => {
		let actionsList = ActionList();

		for (let i = 0; i < actionsList.length; i++) {
			if (actionsList[i].options) {
				for (let j = 0; j < actionsList[i].options.length; j++) {
					if (actionsList[i].options[j].value === actionName) {
						actionLabel = actionsList[i].options[j].label;

						return actionLabel;
					}
				}
			}
		}
		return "";
	};

	actionLabel = FindActionLabel();
	action.label = actionLabel;

	action.name = actionName;

	// console.log("Got action info from action name: ", action);

	return action;
}

export function ActionListV2() {
	return [
		{
			label: "Base de données",
			icon: "fas fa-database",
			actions: [
				{ label: "Base de données", value: "base de données", description: "Lire ou écrire dans une base de données" },
			],
		},
		{
			label: "Fonctions",
			icon: "fas fa-square-root-alt",
			actions: [
				{ label: "Fonctions excel", value: "fonctions excel", description: "Appliquer des formules de type Excel sur les colonnes" },
			],
		},
		{
			label: "IA",
			icon: "fas fa-robot",
			actions: [
				{ label: "ChatGPT", value: "chatgpt_v2", description: "Envoyer une requête à ChatGPT ou à un autre LLM" },
				{ label: "Script personnalisé", value: "fonction", description: "Exécuter du code JavaScript personnalisé" },
			],
		},
		{
			label: "Import / Export",
			icon: "fas fa-file-export",
			actions: [
				{ label: "Envoi de mail", value: "mail", description: "Envoyer un e-mail" },
				{ label: "Fichier", value: "file", description: "" },
				{ label: "xlsx", value: "xlsx", description: "Importer ou générer un fichier Excel (.xlsx)" },
			],
		},
		{
			label: "Lignes & Colonnes",
			icon: "fas fa-table",
			actions: [
				{ label: "Fusionner lignes", value: "fusionner lignes", description: "Regrouper plusieurs lignes en une seule" },
				{ label: "Chercher et classer", value: "chercher et classer", description: "Filtrer et trier les lignes selon des critères" },
				{ label: "Correspondance", value: "correspondance_v2", description: "" },
				{ label: "Mapping colonnes", value: "mapping colonnes", description: "Renommer ou supprimer des colonnes" },
				{ label: "Sort", value: "sort", description: "Trier les lignes selon une ou plusieurs colonnes" },
				{ label: "Split", value: "split", description: "Découper une colonne en plusieurs lignes ou colonnes" },
				{ label: "Split JSON", value: "split_json", description: "Développer un tableau JSON en plusieurs lignes et un objet JSON en plusieurs colonnes" },
				{ label: "Supprimer lignes", value: "supprimer lignes", description: "Supprimer les lignes correspondant à une condition" },
			],
		},
		{
			label: "Règles",
			icon: "fas fa-filter",
			actions: [
				{ label: "Règles", value: "rules", description: "Appliquer des règles conditionnelles sur les données" },
			],
		},
		{
			label: "Service / Connecteur",
			icon: "fas fa-plug",
			actions: [
				{ label: "API", value: "api", description: "Appeler une API HTTP externe" },
				{ label: "Firecrawl", value: "firecrawl", description: "Extraire le contenu de pages web" },
				{ label: "Notifications", value: "send_notifications", description: "Envoyer une notification" },
				{ label: "Planification", value: "agenda", description: "Déclencher ou planifier une action dans le temps" },
				{ label: "Prestashop", value: "prestashop", description: "Interagir avec une boutique Prestashop" },
				{ label: "Projet", value: "projet", description: "Exécuter un autre projet / scénario" },
				{ label: "Traduction", value: "translate", description: "Traduire du texte via un service de traduction" },
			],
		},
	];
}

export const ActionComment = {
	"fonctions excel": "Fonction reprenant les fonctios d'excel",
	"mapping colonnes": "Permet de changer le noms des colonnes et de supprimer les colonnes non renseignées" 
};

// * formaté pour vue-cascader
export function ActionList() {
	return [
		{
			label: "Fonctions",
			value: "Fonctions",
			options: [
				{ label: "Fonction sur colonne", value: "opérations sur colonnes" },
				{ label: "Normalisation", value: "nettoyage" },
				{ label: "Chercher et classer", value: "chercher et classer" },
				{ label: "Référentiel", value: "referentiel" },
				{ label: "Règles", value: "rules" },
		        { label: "Fonctions excel", value: "fonctions excel"},
			],
		},
		{
			label: "Opérations sur lignes et colonnes",
			value: "Opérations sur lignes et colonnes",
			options: [
				{ label: "Supprimer lignes", value: "supprimer lignes" },
				{ label: "Fusionner lignes", value: "fusionner lignes" },
				{ label: "Deux points", value: "deux points" },
				{ label: "Split", value: "split" },
				{ label: "Split json", value: "split_json" },
				{ label: "Sort", value: "sort" },
				{ label: "Séquences", value: "sequence" },
			],
		},
		{
			label: "Mapping",
			value: "Mapping",
			options: [
				{ label: "Mapping", value: "mapping" },
				{ label: "Mapping colonnes", value: "mapping colonnes"},
				{ label: "Mapping colonnes - fichier", value: "mapping colonnes - fichier cible" },
				{ label: "Correspondance", value: "correspondance" },
				{ label: "Correspondance V2", value: "correspondance_v2" },
				{ label: "Conversion", value: "conversion" },
			],
		},
		{
			label: "Appel et enregistrement",
			value: "Appel et enregistrement",
			options: [
				{ label: "Base de données", value: "base de données" },
				{ label: "Partage de document", value: "share_document" },
				{ label: "Partage de document V2", value: "share_document_v2" },
				{ label: "FTP", value: "ftp" },
				{ label: "Projet", value: "projet" },
			],
		},
		{
			label: "Services",
			value: "Services",
			options: [
				{ label: "Hit parade", value: "hit parade" },
				{ label: "Textrazor", value: "textrazor" },
				{ label: "Traduction", value: "translate" },
				{ label: "Scraping", value: "scraping" },
				{ label: "Siren", value: "siren" },
				{ label: "Insee", value: "insee" },
				{ label: "Générer document", value: "html" },
				{ label: "Envoi de mail", value: "mail" },
				{ label: "Docx", value: "docx" },
				{ label: "Ocr", value: "ocr" },
				{ label: "Abbyy", value: "abbyy" },
				{ label: "Ocr - Google Vision", value: "vision" },
				{ label: "Airtable", value: "airtable" },
                { label: "N8n", value: "n8n" },
                { label: "Google Sheets", value: "google_sheets" },
                { label: "ChatGPT", value: "chatgpt" },
                { label: "ChatGPT V2", value: "chatgpt_v2" },
                { label: "Perplexity", value: "perplexity" },
				{ label: "ChatGPT - création fine tuning", value: "chatgpt_train" },				
				{ label: "Planification", value: "agenda" },
				{ label: "Firecrawl", value: "firecrawl" },
				{ label: "Linkedin", value: "linkedin" },
				{ label: "Splash Sync", value: "splashsync" },
				{ label: "Prestashop", value: "prestashop" },
			],
		},
		{
			value: "Mode développeur",
			label: "Mode développeur",
			options: [
				{ label: "Script personnalisé", value: "fonction" },
				{ label: "Mode regex", value: "chercher et remplacer" },
				{ label: "API", value: "api" },
				{ label: "Fichier", value: "file" },
				{ label: "Pdf", value: "pdf" },
				{ label: "Profil utilisateur", value: "user_details" },
				{ label: "Conversion de fichiers", value: "magick_convert" },
				{ label: "Notifications", value: "send_notifications" },
				{ label: "Bibliothèque", value: "library" },
				{ label: "Machine Learning", value: "prediction" },
				{ label: "Analyse pdf - étape 1", value: "pdf_extract" },
				{ label: "Analyse pdf - étape 2", value: "zone_extract" },
				{ label: "Analyse pdf - étape 3", value: "zone_final_extract" },
				{
					label: "Analyse pdf - découpe de document",
					value: "split_zone",
				},
				{ label: "Groupes d'étapes", value: "group" },
				{ label: "Blacklist et whitelist", value: "blacklist_whitelist" },
			],
		},
		{
			value: "Export",
			label: "Export",
			options: [
				{ label: "xlsx", value: "xlsx" },
				{ label: "Zip", value: "zip" },
			],
		},
	];
}

// * groupes d'actions V2, tiers 1, formaté pour cascader
export function ActionListV2_N1() {
	return [
		{
			label: "Extract",
			value: "Extract",
		},
		{
			label: "Ligne et colonne",
			value: "Ligne et colonne",
		},
		{
			label: "Normalisation",
			value: "Normalisation",
		},
		{
			label: "Parser",
			value: "Parser",
		},
		{
			label: "Control",
			value: "Control",
		},
		{
			label: "Conversion",
			value: "Conversion",
		},
		{
			label: "Mapping",
			value: "Mapping",
		},
		{
			label: "Hit parade",
			value: "Hit parade",
		},
		{
			label: "Correspondance",
			value: "Correspondance",
		},
	];
}

// * groupes d'actions V2, tiers 2, formaté pour cascader
export function ActionListV2_N2() {
	return [
		{
			label: "Mode développeur",
			value: "Mode développeur",
		},
		{
			label: "Export",
			value: "Export",
		},
		// {
		//     label: "Predict",
		//     value: "Predict",
		// }
	];
}

export function ActionListDescriptionsN1() {

    // todo get actionlist from server

	return [
		{
			title: "Extract",
			description: "Extraire tous types d'information",
			schemas: [
				//"extraction", // * pas encore implémenté
				"chercher et classer",
			],
			icon: "fas fa-search",
		},
		{
			title: "Ligne et colonne",
			description:
				"Supprimer des lignes et colonnes ou les multiplier/regrouper sur la base de critères communs",
			schemas: ["supprimer lignes", "fusionner lignes", "split"],
			icon: "fas fa-pencil-alt",
		},
		{
			title: "Normalisation",
			description:
				"Normaliser le contenu de cellules (minuscule, majuscule…), modifier des termes à votre vocabulaire",
			schemas: ["nettoyage"],
			icon: "fas fa-check",
		},
		{
			title: "Parser",
			description:
				"Répartissez le contenu d'une cellule dans leurs colonnes dédiées",
			schemas: ["deux points", "split_json", "sequence"],
			icon: "fas fa-sort-alpha-down",
		},
		{
			title: "Control",
			description:
				"Contrôler la validité d'une information comme un numéro de téléphone, mail...",
			schemas: [""], // * service telephone (cf jeremie), service mail test
			icon: "fas fa-crosshairs",
		},
		{
			title: "Conversion",
			description:
				"Convertissez vos données avec vos règles personnalisées",
			schemas: ["conversion"], // * d'autres actions j'imagine ?
			icon: "fas fa-crosshairs",
		},
		{
			title: "Mapping",
			description: "Renommez ou fusionnez vos colonnes.",
			schemas: ["mapping colonnes", "mapping colonnes - fichier cible"],
			icon: "fas fa-exchange-alt",
		},
		{
			title: "Hit parade",
			description: "Comptez le nombre d'occurrences d'une expression",
			schemas: ["hit parade"],
			icon: "fas fa-chart-bar",
		},
		{
			title: "Correspondance",
			description: "Comparez des colonnes entre plusieurs fichiers",
			schemas: ["correspondance"],
			icon: "fa fa-map",
		},
	];
}

export function ActionListDescriptionsN2() {
	let n1Actions = ActionListDescriptionsN1();

    // todo get actionlist from server
	let n2Actions = [
		{
			title: "Mode développeur",
			description: "Développez votre propre script personnalisé.",
			schemas: ["fonction", "api"],
			icon: "fa fa-code",
		},
        {
            title: "Connexion",
            description: "Utilisez des services de transformation de données.",
            schemas: [],
            icon: "fa fa-share-alt",
            children: [
                {
                  title: "Google Sheets",
                  description: "Recevez ou envoyez vos données vers Google Sheets.",
                  image: "https://martechwithme.com/wp-content/uploads/2020/12/2000px-Google_Sheets_logo.svg.png",
                  schemas: ["google_sheets"],
                  icon: "fa fa-share-alt",
                  isChild: true
                },
                {
                    title: "Airtable",
                    description: "Recevez ou envoyez vos données vers Airtable.",
                    image: "https://www.bbb.org/ProfileImages/17382874-098f-4e30-9759-1ac65db6c525.png", // * tmp, peut-être stocké dans la table info
                    schemas: ["airtable"],
                    icon: "fa fa-share-alt",
                    isChild: true
                },
                {
                    title: "N8n",
                    description: "Recevez ou envoyez vos données vers n8n.",
                    image: "https://img.stackshare.io/service/11396/qrGCgo1C_400x400.png", // * tmp, peut-être stocké dans la table info
                    schemas: ["n8n"],
                    icon: "fa fa-share-alt",
                    isChild: true
                },
                {
                    title: "XLSX",
                    description: "Exportez vos données en format .xlsx.",
                    image: "https://static.vecteezy.com/system/resources/previews/000/379/348/original/xlsx-vector-icon.jpg", // * tmp, peut-être stocké dans la table info
                    schemas: ["xlsx"],
                    icon: "fa fa-share-alt",
                    isChild: true
                },
                {
                    title: "Zip",
                    description: "Exportez vos données en format .zip.",
                    image: "https://image.apphit.com/image/filetype/zip/zip-logo.png", // * tmp, peut-être stocké dans la table info
                    schemas: ["zip"],
                    icon: "fa fa-share-alt",
                    isChild: true
                },
            ]
        },
		// {
		//     title: "Predict",
		//     description: "Prévoyez un label à partir d'un jeu de données exemple",
		//     schemas: ["predict"], // * pas encore dev
		// }
	];

	return [...n1Actions, ...n2Actions];
}

/*export default {
    ActionListDescriptionsN1,
    ActionListDescriptionsN2,
    ActionList,
    GetActionInfo
}*/
